import Link from '@mui/material/Link'

/** Opens the registered cluster host without activating a containing table row. */
export const InstallationHostLink = ({ host }: { host: string }) => {
    let href: string | undefined
    if (host && !/[\s/\\@?#%]/.test(host)) {
        try {
            const url = new URL(`https://${host}`)
            // Do not link names that URL normalization changes into a different host.
            if (url.host === host.toLowerCase()) href = url.href
        } catch {
            // Legacy registrations can contain display names rather than hosts.
        }
    }

    return href ? (
        <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            title="Open Network Manager in a new tab"
            onClick={(event) => event.stopPropagation()}
        >
            {host}
        </Link>
    ) : (
        <>{host}</>
    )
}
